import o from "./highrise1348.mjs";
import e from "./highrise1349.mjs";
import t from "./highrise1345.mjs";
import m from "./highrise1347.mjs";
function s(r) {
  return t(r) ? o(m(r)) : e(r);
}
export {
  s as default
};
